import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15c9973a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "tiger_wrapper",
  ref: "tiger"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "license",
  href: "https://pngtree.com/so/cartoon"
}, "cartoon png from pngtree.com/", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("img", {
      class: "tiger_img",
      style: _normalizeStyle(_ctx.transform),
      src: "/xiaolaohu.png",
      alt: ""
    }, null, 4)
  ], 512))
}